import React, { useEffect, useMemo, useState } from "react";
// import "./FindMember.css";
// import "../CommonStyle.css";
// import "../../Styles/FindMember.css";
import "../../Styles/CommonStyles.scss";
// import FMPersonalInfo from "../../components/FindMember/FMPersonalInfo";
// import FMFirmAddress from "../../components/FindMember/FMFirmAddress";
// import FMSections from "../../components/FindMember/FMSections";
// import FMMemberTags from "../../components/FindMember/FMMemberTags";

import {
  Button,
  // Label,
  SecondaryBlueButton,
  // SecondaryButton,
  // SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import MemberServices from "../../services/MemberServices";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
import { PageLink } from "../../components/StyledComp/StyledComp";
// import { TextWrapper } from "../../globalStyles";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";
import ICurrentMember, {
  IPaymentInfo,
  IStateType,
} from "../../store/memberInterfaceStruct";
// import { isGeneratorFunction } from "util/types";
// import Modal from "react-modal";
import ReactModal from "react-modal";
// import InputField from "../StyledComp/InputField";
// import * as routeConfig from "../../config/routes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import {
  // searchMemberApiSlice,
  updateSearchBody,
} from "../../store/searchMemberApiSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  updateSearchParamFlags,
  resetSearchParamFlags,
} from "../../store/hasSearchParamFlags";
import IMember from "../../store/memberInterfaceStruct";
import { updateMemberList } from "../../store/findMemberUpdatedApiSlice";
import {
  setMemberCurrentPage,
  setMemberPaginate,
  setUpdateSortBy,
  setUpdateSortType,
  // updateFM_MemberId,
} from "../../store/memberApiSlice";
import {
  // useTable,
  Column,
  // useSortBy
} from "react-table";
import moment from "moment";
// import AlertIcon from "../../Images/Alert";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import { TextField } from "@mui/material";
import {
  ICost,
  ILocation,
  // IMembership,
  IOrderItem,
  resetOrderParameters,
  storeUpdateOrder,
} from "../../store/orderApiSlice";
import { Controller, useForm } from "react-hook-form";
import { Cost } from "../../store/eventApiSlice";
import OrderServices from "../../services/OrderServices";
import EventMemberPaymentInfo from "./EventMemberPaymentInfo";
import { TRUE } from "sass";
import { initialCurrentMember } from "../../store/currentMemberSlice";
import InvoiceServices from "../../services/InvoiceServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

// interface ISaveSearchBody {
//   SearchName: string;
//   SearchParameters: IConfiguration;
// }

// interface IPagination {
//   TotalRecords: number;
//   TotalAPIPages: number;
// }

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "white",
//     width: 400,
//   },
// };

// let orderItem: IOrderItem = {
//   EventId: "0",
//   MemberCodeId: null,
//   Locations: null,
//   Costs: [],
//   EventName: "",
//   OrderType: "",
//   MemberCode: "",
//   MemberCodeFee: null,
//   MemberCodeDesc: "",
//   EventType: "",
//   ParticipantType: "Attendee",
//   LastYearSections: [],
//   CurrentYearSections: [],
//   membershipItemList: [],
//   VideoCost: 0,
// };

interface IProps {
  callCloseAddMemberModel: () => void;
}

const EventFindMember: React.FC<IProps> = (props) => {
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [adminDateFrom, setAdminDateFrom] = useState<Dayjs | null>(dayjs(null));
  const [adminDateTo, setAdminDateTo] = useState<Dayjs | null>(dayjs(null));
  const [invoiceURL, setinvoiceURL] = useState<string>("");
  const form = useForm<IPaymentInfo>();
  const { control } = form;

  const [orderEventDetailModalOpen, setOrderEventDetailModalOpen] =
    useState<boolean>(false);

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  // const orderInfo = useAppSelector((store) => store.orderapislice);

  // const hasSearchParamFlags = useSelector(
  //   (state: RootState) => state.hasSearchParamFlags
  // );
  // const sectionNameArray = useSelector(
  //   (state: RootState) => state.searchMemberApiSlice.SectionIn ?? []
  // );
  // const executeNameArray = useSelector(
  //   (state: RootState) => state.searchMemberApiSlice.SectionNotIn ?? []
  // );
  // const tagsIn = useSelector(
  //   (state: RootState) => state.searchMemberApiSlice.TagIn ?? []
  // );
  // const tagsNotIn = useSelector(
  //   (state: RootState) => state.searchMemberApiSlice.TagsNotIn ?? []
  // );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const currentPage = useSelector(
    (state: RootState) => state.memberApiSlice.CurrentPage
  );
  const updatePage = useSelector(
    (state: RootState) => state.memberApiSlice.Paginate
  );

  let storeTrasactionAmount = useAppSelector(
    (store) => store.orderapislice.TotalAmount
  );

  // const orderDetail = useAppSelector((store) => store.orderapislice);
  // const [orderItemsForComputeCost, setOrderItemsForComputeCost] = useState<
  //   IOrderItem[]
  // >(orderDetail?.Orders);

  const orderInfo = useAppSelector((store) => store.orderapislice);

  const [member, setMember] = useState<IMember>();

  const [CurrentPage, setCurrentPage] = useState(currentPage);
  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(currentPage);
  const [MembersPerPage, setMembersPerPage] = useState(updatePage);
  // const [Pagination, setPagination] = useState<IPagination[]>();
  const [TotalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let startIndex = 0;
  let endIndex = 0 + MembersPerPage;

  const updateSortType = useSelector(
    (state: RootState) => state.memberApiSlice.SortType
  );
  const updateSortBy = useSelector(
    (state: RootState) => state.memberApiSlice.SortBy
  );
  const [SortType, setSortType] = useState(updateSortType);
  const [SortField, setSortField] = useState(updateSortBy);

  const [memberList, setMemberList] = useState<IMember[]>([]);
  const [CurrentMemberListPage, setCurrentMemberListPage] = useState<IMember[]>(
    []
  );
  const [TotalAPIPages, setTotalAPIPages] = useState(0);
  const [initialMemberLoadFlag, setInitialMemberLoadFlag] =
    useState<boolean>(false);
  // const [member, setMember] = useState<IMember>();

  useEffect(() => {
    dispatch(resetSearchParameters());
    dispatch(resetSearchParamFlags());

    dispatch(resetOrderParameters());

    const getConfigurationLists = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
  }, []);

  useEffect(() => {
    if (initialMemberLoadFlag === true) {
      getMemberList();
    }
  }, [CurrentAPICallPage, SortField, SortType, MembersPerPage]);

  const searchParameters: IStateType = useAppSelector(
    (state) => state.searchMemberApiSlice
  );

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("updateInput");
    // console.log(event.target.name, " .. ", event.target.value);
    dispatch(
      updateSearchBody({ key: event.target.name, value: event.target.value })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const setConsolidatedDate = (passedDate: Dayjs, type: string) => {
    console.log("setConsolidatedDate", passedDate, type);
    // console.log(new Date(passedDate))
    // console.log(new Date(passedDate).toISOString())
    dispatch(
      updateSearchBody({
        key: type,
        value: passedDate.format("YYYY-MM-DD"),
      })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const showMemberList = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("showMemberList CALLED");
    setInitialMemberLoadFlag(true);
    getMemberList();
  };

  const getMemberList = async () => {
    setIsLoading(true);

    let memberListAPIParams = {
      ...searchParameters,
      CurrentPage: CurrentAPICallPage,
      SortType: SortType,
      SortBy: SortField,
      Paginate: MembersPerPage,
      // IsActive: 1,
    };
    console.log("memberListAPIParams:", memberListAPIParams);
    const response = await MemberServices.getMemberList(memberListAPIParams);

    console.log("isLoading:", isLoading);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      setMemberList((prevMemberList) => [
        ...prevMemberList,
        ...response.data.data.Members,
      ]);
      setCurrentMemberListPage(response.data.data.Members);
      // setCurrentMemberListPage(
      //   response.data.data.Members.slice(startIndex, endIndex)
      // );
      setTotalRecords(response.data.data.Pagination[0].TotalRecords);
      setTotalAPIPages(response.data.data.Pagination[0].TotalAPIPages);

      dispatch(
        updateMemberList(response.data.data.Members.slice(startIndex, endIndex))
      );
      dispatch(setMemberCurrentPage(memberListAPIParams.CurrentPage));
      dispatch(setMemberPaginate(memberListAPIParams.Paginate));
      dispatch(setUpdateSortType(memberListAPIParams.SortType));
      dispatch(setUpdateSortBy(memberListAPIParams.SortBy));
      setIsLoading(false);
      console.log("isLoading:", isLoading);
    } else {
      setMemberList([]);
      setIsLoading(false);
    }
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "BarId", Header: "BarID", accessor: "BarId" },
      { id: "FirstName", Header: "FirstName", accessor: "FirstName" },
      { id: "LastName", Header: "LastName", accessor: "LastName" },
      { id: "MemberCode", Header: "MemberCode", accessor: "MemberCode" },
      { id: "MemberType", Header: "MemberType", accessor: "MemberType" },
      // { id: "Phoneno", Header: "Phone Number", accessor: "Phoneno" },
      // { id: "Gender", Header: "Gender", accessor: "Gender" },
      {
        id: "AdmitDate",
        Header: "AdmitDate",
        accessor: (AdmitDate) => {
          return moment(AdmitDate.AdmitDate).local().format("MM-DD-YYYY");
        },
      },
      { id: "MemberStatus", Header: "Status", accessor: "MemberStatus" },
      {
        id: "Action",
        Header: "Action",
        accessor: "Action",
      },
    ],
    []
  );

  const memberData = useMemo(() => memberList, [memberList]);

  // const TableInstance = useTable(
  //   {
  //     columns,
  //     data: memberData,
  //   },
  //   useSortBy
  // );

  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   rows,
  //   prepareRow,
  //   // selectedFlatRows,
  // } = TableInstance;

  const handlePageChange = (value: number) => {
    console.log("handlePageChange:", value);
    setCurrentPage(value);
    setCurrentAPICallPage(value);
  };

  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setMemberList([]);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
    startIndex = 0;
    endIndex = 0 + MembersPerPage;
    setSortType(
      newSortField === SortField
        ? SortType === "Desc"
          ? "Asc"
          : "Desc"
        : "Asc"
    );
    setSortField(newSortField);
  };

  const renderSortIcon = (field: string) => {
    if (field === SortField) {
      return SortType === "Desc" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M4 13h16l-8 8z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
        </svg>
      );
    }
  };
  const updateNoOfMembersPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    setMembersPerPage(Number(event.target.value));
    // setMembersPerAPICall(Number(event.target.value) * 2);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  const handleSendInvoice = async () => {
    if (
      member &&
      member.PrimaryAddress &&
      member.PrimaryAddress.Email === null &&
      member.PublishedAddress &&
      member.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: invoiceURL,
      FirstName: member && member.FirstName,
      LastName: member && member.LastName,
      Esquired: member && member.Esquire,
      MemberEmail:
        member && member.PrimaryAddress && member && member.PrimaryAddress.Email
          ? member && member.PrimaryAddress.Email
          : member &&
            member.PublishedAddress &&
            member &&
            member.PublishedAddress.Email,
    };

    const response = await MemberServices.sendCLEReceiptEmailToMember(body);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      props.callCloseAddMemberModel();
      // navigate("/member", { replace: false });
    } else {
      props.callCloseAddMemberModel();
      console.log("error", response);
    }
    setViewInvoiceModalOpen(false);
  };

  const openOrderEventDetail = (
    event: React.MouseEvent<HTMLElement>,
    member: IMember
  ) => {
    console.log(
      "openOrderEventDetail:",
      existPaticipantList(member),
      "-",
      member.Id
    );
    setOrderEventDetailModalOpen(true);
    console.log("EventFindMember Select:", member.Id);
    setMember(member);
  };

  // const handleCancel = () => {
  //   setOrderEventDetailModalOpen(false);
  //   // setEventCostList([]);
  //   // setEventCostIdList([]);
  //   // setTransactionAmount(0);
  //   // dispatch(resetOrderParameters());
  // };

  const callCreateOrderAPI = async () => {
    // alert("callCreateOrderAPI");
    console.log("onSUBMIT:", orderInfo);
    setModalOpen(false);
    const apiBody: any = orderInfo;
    const response = await OrderServices.createOrder(apiBody);
    dispatch(resetOrderParameters());

    console.log("callCreateOrderAPI response", response);
    // alert("response received");
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      // alert("Order Created successfully");
      // dispatch(resetOrderParameters());  I am doing this in useEffect
      // navigate("/order", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      if (orderInfo.NoInvoice === false) {
        const apiBody1: any = {
          orderId: response.data.data.insertId,
          memberId: orderInfo.MemberId,
          paymentStaus: 1, //invoice created
        };

        const response1 = await InvoiceServices.createOrderInvoiceSync(
          apiBody1
        );
        console.log("INVOICE response", response1.data.data);
        // console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
        console.log("INVOICE URL", response1.data.data);
        if (response1.data.data !== "NULL") {
          if (response1.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response1.data.errors[0].sqlMessage);
            return;
          }
          setinvoiceURL(response1.data.data);
          setViewInvoiceModalOpen(true);
          console.log("invoice url:", response1.data.data);
          setinvoiceURL(response1.data.data);
          setOrderEventDetailModalOpen(false);
          setViewInvoiceModalOpen(true);
          console.log("member:", member);
        }
      } else {
        props.callCloseAddMemberModel();
      }
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const existPaticipantList = (member: IMember) => {
    // console.log("existPaticipantList-member:", member.Id);
    if (
      eventInfo &&
      eventInfo.OrderDetail &&
      eventInfo.OrderDetail.length > 0
    ) {
      for (const orderDetailItem of eventInfo.OrderDetail) {
        // console.log("orderDetailItem.MemberId", orderDetailItem.MemberId);
        if (member.Id === orderDetailItem.MemberId) {
          console.log(member.Id, "=", orderDetailItem.MemberId);
          return true;
        }
      }
    }
    return false;

    // eventInfo &&
    // eventInfo.OrderDetail &&
    // eventInfo.OrderDetail.length > 0 &&
    // eventInfo.OrderDetail.map((orderDetailItem) => {
    //   console.log("orderDetailItem.MemberId", orderDetailItem.MemberId);
    //   if (member.Id === orderDetailItem.MemberId) {
    //     console.log(member.Id, "=", orderDetailItem.MemberId);
    //     return true;
    //   }
    // });
  };

  return (
    <>
      <div
        className="dashboard-wrapper-sticky-submit-button"
        style={{ overflow: "auto" }}
      >
        <div
          className="dashboard-content-wrapper dashboard-wrapper-sticky-submit-button"
          style={{ paddingBottom: "5px" }}
        >
          <form
            // onSubmit={openMemberListScreen}
            onSubmit={(e) => showMemberList(e)}
          >
            <div className="form-wrapper">
              <div className="input-field-div-wrapper">
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="MemberId"
                  name="MemberId"
                  autoComplete="off"
                  onChange={updateInput}
                />
                <label className="form-label" htmlFor="MemberId">
                  BarID
                </label>
              </div>

              <div className="input-field-div-wrapper">
                <input
                  className="input-field-div-small"
                  id="FirstName"
                  placeholder=""
                  name="FirstName"
                  onChange={updateInput}
                />
                <label className="form-label" htmlFor="FirstName">
                  First Name
                </label>
              </div>

              <div className="input-field-div-wrapper">
                {/* <Label>Last Name</Label> */}
                <input
                  className="input-field-div-small"
                  id="LastName"
                  name="LastName"
                  placeholder=""
                  onChange={updateInput}
                />
                <label className="form-label" htmlFor="LastName">
                  Last Name
                </label>
              </div>
              {/* <div className="submit-floating-button-div"> */}
              <div className="horizontal-wrapper-centeralign">
                <Button className="submit-button-div" type="submit">
                  Search
                </Button>
              </div>
              {/* </div> */}
            </div>
          </form>

          {initialMemberLoadFlag ? (
            <>
              <div
                className="dashboard-content-wrapper"
                style={{ paddingBottom: "1rem" }}
              >
                <div className="memberlist-table">
                  <table>
                    <thead>
                      <tr>
                        <th onClick={() => handleSort("BarId")}>
                          BarID{renderSortIcon("BarId")}
                        </th>
                        <th onClick={() => handleSort("FirstName")}>
                          FirstName{renderSortIcon("FirstName")}
                        </th>
                        <th onClick={() => handleSort("LastName")}>
                          LastName{renderSortIcon("LastName")}
                        </th>
                        <th onClick={() => handleSort("MemberCode")}>
                          MemberCode{renderSortIcon("MemberCode")}
                        </th>
                        <th onClick={() => handleSort("MemberType")}>
                          MemberType{renderSortIcon("MemberType")}
                        </th>
                        <th onClick={() => handleSort("AdmitDate")}>
                          AdmitDate{renderSortIcon("AdmitDate")}
                        </th>
                        <th onClick={() => handleSort("IsCurrentYearDuePaid")}>
                          Status{renderSortIcon("IsCurrentYearDuePaid")}
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {memberList.length === 0 ? (
                      isLoading ? (
                        <tbody>
                          <tr>
                            <td align="center" colSpan={9}>
                              <span>Loading...</span>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td align="center" colSpan={9}>
                              <span>No record Found</span>
                            </td>
                          </tr>
                        </tbody>
                      )
                    ) : (
                      <tbody>
                        {CurrentMemberListPage.map((member) => (
                          <tr key={member.Id}>
                            <td>{member.BarId}</td>
                            <td>{member.FirstName} </td>
                            <td>{member.LastName} </td>
                            <td>{member.MemberCode} </td>
                            <td>{member.MemberType} </td>
                            <td>
                              {member.AdmitDate != null
                                ? dayjs(member.AdmitDate).format("MM-DD-YYYY")
                                : "--"}
                            </td>
                            <td>
                              {member.IsCurrentYearDuePaid === 1 ? (
                                <span style={{ color: "green" }}>Active</span>
                              ) : (
                                <span style={{ color: "red" }}>Expired</span>
                              )}
                            </td>
                            <td>
                              <SecondaryBlueButton
                                className="button-wrapper"
                                type="button"
                                onClick={(e) => openOrderEventDetail(e, member)}
                                disabled={existPaticipantList(member)}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  {existPaticipantList(member)
                                    ? "Added"
                                    : "Select"}
                                </span>
                              </SecondaryBlueButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
              <div
                className="container"
                style={{ paddingTop: "10px", borderTop: "1px solid #ddd" }}
              >
                <div className="grid left"></div>

                <div className="grid center">
                  <div className="horizontal-wrapper-centeraligned">
                    <div
                      className="round-button-div"
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "10px",
                      }}
                    >
                      <RoundButtonWithIcon
                        icon={<LeftArrowIcon height={15} width={8} />}
                        onClick={() => handlePageChange(CurrentPage - 1)}
                        disabled={CurrentPage === 1}
                      />
                    </div>

                    {CurrentMemberListPage.length > 1 ? (
                      <div className="heading_medium">
                        {" "}
                        <span style={{ fontWeight: "500" }}>
                          {1 + (CurrentPage - 1) * MembersPerPage}{" "}
                        </span>{" "}
                        -{" "}
                        <span style={{ fontWeight: "500" }}>
                          {CurrentMemberListPage.length +
                            (CurrentPage - 1) * MembersPerPage}{" "}
                        </span>
                        of{" "}
                        <span style={{ fontWeight: "500" }}>
                          {TotalRecords}{" "}
                        </span>{" "}
                        members
                      </div>
                    ) : (
                      <div>
                        <div className="heading_medium">
                          <span style={{ fontWeight: "500" }}>
                            {TotalRecords}{" "}
                          </span>{" "}
                          members
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        height: "30px",
                        width: "30px",
                        transform: "rotate(180deg)",
                        marginLeft: "10px",
                      }}
                    >
                      {" "}
                      <RoundButtonWithIcon
                        icon={<LeftArrowIcon height={15} width={8} />}
                        onClick={() => handlePageChange(CurrentPage + 1)}
                        disabled={
                          CurrentPage ===
                          Math.ceil(TotalRecords / MembersPerPage)
                        }
                      />{" "}
                    </div>
                  </div>
                </div>
                <div className="grid right">
                  <select
                    className="dropdown-control-large-insidetextfield"
                    name="pagesize"
                    style={{ border: "1px solid #ddd" }}
                    onChange={(e) => {
                      updateNoOfMembersPerPage(e);
                    }}
                    value={MembersPerPage ?? ""}
                  >
                    <option value="10">10 rows</option>
                    <option value="25">25 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                    <option value="150">150 rows</option>
                    <option value="200">200 rows</option>
                  </select>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>

        {/* pagination control */}
      </div>
      <ReactModal
        isOpen={orderEventDetailModalOpen}
        onRequestClose={() => setOrderEventDetailModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading" style={{ marginBottom: "2rem" }}>
            Update Cost and Payment Information
          </h1>
          <PageLink
            onClick={() => {
              dispatch(resetOrderParameters());
              setOrderEventDetailModalOpen(false);
            }}
            style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        <EventMemberPaymentInfo
          member={member!}
          callOrderAPI={callCreateOrderAPI}
          // orderType={eventInfo.EventType!} // Seminar, Function, Video
          operationType="CREATE"
        />
      </ReactModal>
      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => {
          setViewInvoiceModalOpen(false);
          props.callCloseAddMemberModel();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View INVOICE</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button
                type="submit"
                onClick={() => {
                  setViewInvoiceModalOpen(false);
                  props.callCloseAddMemberModel();
                }}
              >
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email Receipt
              </Button>
            </div>
          </div>
          <div className="pdf-container">
            <iframe src={invoiceURL} allow="autoplay" loading="lazy"></iframe>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default EventFindMember;
